import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {FEATURE_USERS_CUSTOM_FIELDS} from "../../../../core/gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../const";

export default class UserCustomFieldsSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "User Custom Fields",
            description              : "The User Custom Fields module allows administrators to add custom fields to company user profiles for better organization and HR purposes. This feature enables the creation of fields tailored to specific needs, such as  job title, contact information, etc. By customizing user profiles with relevant details, organizations can streamline internal processes and improve HR management efficiency.",
            svgIcon                  : "isvg-user-fields",
            settingsUrl              : "settings/user-custom-fields",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            typeLabel                : "Company users",
            feature                     : FEATURE_USERS_CUSTOM_FIELDS
        });

        this.parentSection          = SettingsParentSection.COMPANY_USERS
    }

}
